<div class="card border mt-2">
    <div class="card-body p-2">
        <h5 *ngIf="props.label"
            class="card-title border-bottom pb-2">{{ props.label }}</h5>
        <p *ngIf="props.description"
           class="card-text">
            {{ props.description }}
        </p>
        <ng-container #fieldComponent></ng-container>
    </div>
</div>